export var formHelperTextLocale = {
  errorIconTitle: 'Error:'
};